export function getTooltipHtml (content, title, type = 'multi') {
  if (type === 'single') {
    content = content.map(item => {
      return `
        <span class="chart-value">${escapeHtml(item[0])}</span>
        <span>${escapeHtml(item[1])}</span>
      `
    })
  } else {
    content = content.map(item => {
      const isEtc = item[2] && item[2] === 'etc'
      return `
        <span class="chart-left ${isEtc ? 'etc' : ''}">${escapeHtml(item[0])}</span>
        <span class="chart-right chart-value ${isEtc ? 'etc' : ''}">${escapeHtml(item[1])}</span>
      `
    })
  }

  if (title) {
    content.unshift(`<span class="chart-title">${escapeHtml(title)}</span>`)
  }
  return `<div class="chart_tooltip">${content.join('<br>')}</div>`
}

function escapeHtml (text) {
  return String(text).replace(/&/g, '&amp;')
}
